// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminRolesForm-textWidth-nPIEs {
	font-size: 16px;
	font-weight: 400;
	color: var(--primary-foreground);
}

.AdminRolesForm-checkboxLabelContainer-Io57r {
	margin-bottom: 12px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/AdminRolesForm/AdminRolesForm.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;AAC5B","sourcesContent":[".textWidth {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: var(--primary-foreground);\n}\n\n.checkboxLabelContainer {\n\tmargin-bottom: 12px;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textWidth": `AdminRolesForm-textWidth-nPIEs`,
	"checkboxLabelContainer": `AdminRolesForm-checkboxLabelContainer-Io57r`
};
module.exports = ___CSS_LOADER_EXPORT___;
